import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=32644cca&"
import script from "./Notifications.vue?vue&type=script&lang=js&"
export * from "./Notifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/samenaankoop/src/vue-apps/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32644cca')) {
      api.createRecord('32644cca', component.options)
    } else {
      api.reload('32644cca', component.options)
    }
    module.hot.accept("./Notifications.vue?vue&type=template&id=32644cca&", function () {
      api.rerender('32644cca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "widgets/Notifications.vue"
export default component.exports